export const INSERTION_LOSS_FREQUENCIES = ['63', '125', '250', '500', '1000', '2000', '4000', '8000'];

export function parseInsertionLossCsv(csv) {
  let arr = csv.split(/\r?\n/).filter((line) => line.length > 0);
  let jsonObj = [];
  let headers = arr[0].split(';');

  for (let i = 1; i < arr.length; i++) {
    let data = arr[i].split(';');
    let obj = {};

    for (let j = 0; j < data.length; j++) {
      obj[headers[j].trim()] = data[j].trim();
    }
    jsonObj.push(obj);
  }
  JSON.stringify(jsonObj);
  return jsonObj;
}

export function getDelta(x, y) {
  var delta = x - y;
  return delta;
}

export function getMinTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2) {
  return daten
    .filter((x) => x['Typ'] === Muss1 && parseFloat(x['Dicke']) === Muss2)
    .sort((a, b) => a[Xname] - b[Xname] || a[Yname] - b[Yname])
    .find((x) => Math.min(x[Xname]) >= XSoll && Math.min(x[Yname]) >= YSoll);
}

export function getMaxTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2) {
  return daten
    .filter((x) => x['Typ'] === Muss1 && parseFloat(x['Dicke']) === Muss2)
    .sort((a, b) => b[Yname] - a[Yname] || b[Xname] - a[Xname])
    .find((x) => Math.max(x[Xname]) <= XSoll && Math.max(x[Yname]) <= YSoll);
}

export function getDeltaWert(daten, xSoll, ySoll, Xname, Yname, Dname, musskriterium1, musskriterium2) {
  // Interpoliert die Datensätze min/max
  // XSoll/YSoll ist der gesucht Wert der sich auf Xname/YName bezieht
  // Dname gibt den den zu Interpolierenden wert an.

  let XSoll = parseFloat(xSoll);
  let YSoll = parseFloat(ySoll);

  let min = getMinTuple(daten, XSoll, YSoll, Xname, Yname, musskriterium1, musskriterium2);
  let max = getMaxTuple(daten, XSoll, YSoll, Xname, Yname, musskriterium1, musskriterium2);
  if (min === undefined || max === undefined) {
    return 0;
  } else {
    let deltaX = 0;
    let deltaXSoll = 0;
    let deltaY = 0;
    let deltaYSoll = 0;
    let deltaD = 0;
    let d1 = 0;
    let d = 0;

    deltaX = getDelta(parseFloat(max[Xname]), parseFloat(min[Xname]));
    deltaXSoll = getDelta(parseFloat(XSoll), parseFloat(min[Xname]));
    deltaY = getDelta(parseFloat(max[Yname]), parseFloat(min[Yname]));
    deltaYSoll = getDelta(parseFloat(YSoll), parseFloat(min[Yname]));
    deltaD = parseFloat(max[Dname]) - parseFloat(min[Dname]);
    d1 = parseFloat(min[Dname]);

    // Wenn Delta d==0 dann nur d1 zurückgeben
    if (deltaD === 0) {
      return d1;
    }
    let deltaDIVX = 0;
    if (isNaN((deltaXSoll / deltaX))) {
      deltaDIVX = 0;
    } else {
      deltaDIVX = Math.pow((deltaXSoll / deltaX), 2);
    }

    let deltaDIVY = 0;
    if (isNaN((deltaYSoll / deltaY))) {
      deltaDIVY = 0;
    } else {
      deltaDIVY = Math.pow((deltaYSoll / deltaY), 2);
    }

    let calc = Math.sqrt(deltaDIVX + deltaDIVY);
    d = d1 + deltaD * calc;

    return d;
  }
}

export function calculateInsertionLossValue({
  daten,
  Kulissenspalt,
  Kulissenlaenge,
  Kulissentyp,
  Kulissenbreite,
  Dname,
}) {
  let Xname = 'Spalt';
  let Yname = 'Laenge';

  let xSoll1 = parseFloat(Kulissenspalt);
  let ySoll1 = parseFloat(Kulissenlaenge);
  let musskriterium1 = Kulissentyp;
  let musskriterium2 = parseFloat(Kulissenbreite);

  return getDeltaWert(daten, xSoll1, ySoll1, Xname, Yname, Dname, musskriterium1, musskriterium2);
}

export function calculateInsertionLoss({
  daten,
  Kulissenspalt,
  Kulissenlaenge,
  Kulissentyp,
  Kulissenbreite,
}) {
  return INSERTION_LOSS_FREQUENCIES.reduce((result, frequency) => {
    let value = calculateInsertionLossValue({
      daten,
      Kulissenspalt,
      Kulissenlaenge,
      Kulissentyp,
      Kulissenbreite,
      Dname: frequency,
    });

    result[`hz${frequency}`] = Number(value.toFixed(0));
    return result;
  }, {});
}
